import { createActionConst } from '../../../utils/action.utils';

const MEETING_SIMPLE_NAMESPACE = 'MEETING_SIMPLE';

export const STORE_MEETING_SIMPLE = createActionConst(MEETING_SIMPLE_NAMESPACE, 'STORE_MEETING_SIMPLE');
export const CLEAR_MEETING_SIMPLE = createActionConst(MEETING_SIMPLE_NAMESPACE, 'CLEAR_MEETING_SIMPLE');
